export default __webpack_public_path__ + "static/user-circle-4-c7034a37cccb86119cdd3a8882ba8c2a.png";